/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
    if (!value) return value
    const phoneNumber = value.replace(/[^\d]/g, '')
    const phoneNumberLength = phoneNumber.length
    if (phoneNumberLength < 4) return phoneNumber
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

export const E164_PHONE_PATTERN = /^\+\d{3,}$/

const E164_PHONE_PLACEHOLDERS = {
    AT: '+436641234567',
    AU: '+61412345678',
    BE: '+32470123456',
    BG: '+359881234567',
    CA: '+14165551234',
    CZ: '+420601123456',
    DE: '+491711234567',
    DK: '+4520123456',
    EE: '+37251234567',
    ES: '+34612345678',
    FI: '+358401234567',
    FR: '+33612345678',
    GB: '+447911123456',
    HR: '+385911234567',
    IE: '+353851234567',
    IT: '+393331234567',
    JP: '+819012345678',
    KR: '+821012345678',
    LT: '+37061234567',
    LU: '+352621123456',
    LV: '+37121234567',
    NL: '+31612345678',
    PL: '+48500123456',
    PT: '+351912345678',
    RO: '+40722123456',
    SE: '+46701234567',
    SI: '+38640123456',
    SK: '+421901234567',
    TR: '+905321234567',
    US: '+14155552671'
}

export const getE164PhonePlaceholder = (countryCode) =>
    E164_PHONE_PLACEHOLDERS[countryCode?.toUpperCase()] || '+123'

export const normalizePhoneToE164 = (value) => {
    if (!value) return ''

    const trimmedValue = value.trim()

    if (!trimmedValue) return ''

    return E164_PHONE_PATTERN.test(trimmedValue) ? trimmedValue : null
}

export const getSmsDeliveryPhoneData = (value) => {
    const phone = normalizePhoneToE164(value) || ''

    return {
        phone
    }
}
